module.exports = {
    name: 'Purchase Exception',
    gen_template: `
       {
          "coa": "ASSET",
          "Icon": "{{random.alphaNumeric}}{{random.number}}{{random.alphaNumeric}}{{random.number}}", 
          "name": "{{lorem.word}}"
       }
    `,
    wizard: {
        actionBtn: 'Save',
        action: 'add_accounting_purchase_exception',
        pages: [
            {
                title: 'Purchase Exception',
                subtitle: 'Configure new Purchase Exception',
                forms: [
                    {
                        type: 'select', class: 'col-12', label: "Field Code", model: 'field_code',
                        validation: 'required',
                    },
                    {
                        type: 'text', form_type: 'text', label: 'Name', model: 'rule_name',
                        validation: 'required|min:3|max:150', class: 'col-12 col-md-6'
                    },

                    {
                        type: 'text', class: 'col-12 col-md-6', label: "Operand", model: 'rule_operand',
                        validation: 'required',
                    },
                    {
                        type: 'textarea', form_type: 'text', label: 'Description', model: 'rule_description',
                        validation: 'required|min:10|max:500', class: 'col-12'
                    },
                ],
            },

        ]
    },
    updateWizard: {
        actionBtn: 'Update',
        action: 'update_purchase_exception',
        pages: [
            {
                title: 'Purchase Exception',
                subtitle: 'Update Purchase Exception',
                forms: [
                    {
                        type: 'textarea', form_type: 'text', label: 'Description', model: 'rule_description',
                        validation: 'required|min:10|max:500', class: 'col-12'
                    },
                ]
            }
        ]
    },

    verifyWizard: {
        actionBtn: 'Verify',
        action: 'verify_purchase_exception',
        pages: [
            {
                title: 'Purchase Exception',
                subtitle: 'Verify Purchase Exception',
                forms: [
                    {
                        type: 'textarea', form_type: 'text', label: 'Remarks', model: 'remarks',
                        validation: 'required|min:10|max:500', class: 'col-12'
                    },
                ]
            }
        ]
    },
    table: {
        title: 'Purchase Exception',
        subtitle: 'A list of configured purchase exceptions',
        table_fields: [
            // { name: 'Field Code', align: 'l' },
            { name: 'Name', align: 'l' },
            { name: 'Operand', align: 'l' },
            { name: 'Description', align: 'l' },
            { name: 'actions', align: 'c' }
        ],
        searchFields: ["rule_description", "rule_name", "rule_operand"],
        rowData: [
            // { type: 'text', field: 'field_code', class: 'left bolder small' },
            { type: 'text', field: 'rule_name', class: 'left bolder' },
            { type: 'text', field: 'rule_operand', class: 'left bolder' },
            { type: 'text', field: 'rule_description', class: 'left bolder' },
            {
                type: 'action', field: 'name', class: 'center', icon: '', actions: [
                    // {type: 'title', title: 'Actions'},
                    // {
                    //     type: 'menu', title: 'Edit', event: 'client:edit', icon: 'ico-right', params: [
                    //     { key: 'client', field: '*' }
                    //     ]
                    // },
                    
                    {
                        type: 'menu', title: 'View', event: 'PurchaseException:view', icon: 'ico-reply', params: [
                            { key: 'PurchaseException', field: '*' },
                        ]
                    },
                    // {
                    //     type: 'menu', title: 'Verify', event: 'PurchaseException:verify', icon: 'ico-thumbs-up', params: [
                    //         { key: 'PurchaseException', field: '*' },
                    //     ]
                    // },
                    // {
                    //     type: 'menu', title: 'Delete', event: 'PurchaseException:delete', icon: 'ico-thumbs-up', params: [
                    //         { key: 'PurchaseException', field: '*' },
                    //     ]
                    // },

                ]
            },
        ]
    },
}